export const IMAGE_SIZES = {
  THUMBNAIL: { width: 105, height: 140 },
  MEDIUM: { width: 336, height: 504 },
  LARGE: { width: 800, height: 600 },
} as const;

export const PREGENERATED_COMBINATIONS = Object.values(IMAGE_SIZES);

export const ALLOWED_WIDTHS = [...new Set(PREGENERATED_COMBINATIONS.map((s) => s.width))];
export const ALLOWED_HEIGHTS = [...new Set(PREGENERATED_COMBINATIONS.map((s) => s.height))];
